import { createFeatureGate } from './createFeatureGate';

export const [useFeatureGateClusterCreation, checkFeatureGateClusterCreation] = createFeatureGate(
  'cluster_creation_enabled',
  { default: true },
);

export const [useFeatureGateMultiAccountBillingPage, checkMultiAccountBillingPageFeatureGate] =
  createFeatureGate('multi_account_billing_page');

export const [useFeatureGateServerless, checkServerlessFeatureGate] = createFeatureGate('serverless');

export const [useFeatureGateMfaPasskey, checkFeatureGateMfaPasskey] = createFeatureGate('enable_mfa_passkey');

export const [useFeatureGateNodeDowntimeReason] = createFeatureGate('node_downtime_reason');

export const [useFeatureGateDiskDownscaling] = createFeatureGate('disk_downscaling');

export const [useFeatureGateAuditLoggingOutput] = createFeatureGate('audit_logging_output');

// Temporary: a kill switch to revert to browser pricing on prod if server pricing misbehaves.
// Remove together with the browser-pricing path once server pricing is stable.
export const [useFeatureGateServerPricing] = createFeatureGate('calculator_server_pricing_enabled');

// The OAuth entry points: Security > Connected Apps and the Access Management tab. The consent page is
// not gated: only the Auth0 post-login Action sends people there.
export const [useFeatureGateOAuth, checkFeatureGateOAuth] = createFeatureGate('oauth');
